
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search-homes",
      function () {
        return require("private-next-pages/search-homes/index.tsx");
      }
    ]);
  